import React, { useEffect, useState } from 'react';
import { IntlProvider, MessageFormatElement } from 'react-intl';
import { sharedUtilsGetLang } from '../../../../utils/lang-utils';
import { SustainabilityScanFormSections } from './sections';
import { API_ASSETS } from '../../../../services';

export const SustainabilityScanForm: React.FunctionComponent = () => {
  const [locale] = useState(sharedUtilsGetLang());
  const [messages, setMessages] = useState<Record<string, MessageFormatElement[]>>(
    {} as Record<string, MessageFormatElement[]>
  );

  useEffect(() => {
    const loadData = async () => {
      const data: Record<string, MessageFormatElement[]> = await API_ASSETS.get(
        `forms/sustainability-scan/compiled-lang/${locale}.json`
      );

      setMessages(data);
    };

    loadData();
  }, [locale]);

  return (
    <>
      {messages && Object.keys(messages).length > 0 && (
        <IntlProvider locale={locale} messages={messages} defaultLocale={'nl'}>
          <SustainabilityScanFormSections />
        </IntlProvider>
      )}

      {messages && !Object.keys(messages).length && <div>Loading...</div>}
    </>
  );
};
